function updateFloatingOverlays(section) {
    if (!section) return;

    section.querySelectorAll('.sc-slide').forEach((slide) => {
        const overlay = slide.querySelector('.sc-floating-overlay');
        if (!overlay) return;

        const slideTrack = slide.closest('.sc-slideshow-track') || section.querySelector('.sc-slideshow-track');
        if (!slideTrack) return;

        // Read base bottom from CSS rules (e.g. media queries) instead of previous inline calculations.
        overlay.style.bottom = '';
        const computedBottom = parseFloat(window.getComputedStyle(overlay).bottom);
        const baseBottom = Number.isFinite(computedBottom) ? computedBottom : 0;
        const nextBottom = baseBottom + slide.offsetHeight - slideTrack.offsetHeight;
        overlay.style.bottom = `${nextBottom}px`;
    });
}

class CardsCarouselSC {
    constructor(container) {
        this.container = container;
        this.wrapper = container.querySelector('.sc-slider-wrapper');
        this.slider = container.querySelector('.sc-cards-list');
        this.cardsPaginationContainer = container.querySelector('.sc-cards-pagination');
        this.items = Array.from(container.querySelectorAll('.sc-card-item'));
        this.pagination = container.querySelector('[data-card-pagination]');

        if (!this.wrapper || !this.slider || !this.pagination || this.items.length < 2) return;

        this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
        this.totalPagesElement = this.pagination.querySelector('.slider-counter--total');
        this.handleUpdate = this.update.bind(this);
        this.resizeObserver = new ResizeObserver(this.handleUpdate);

        this.resizeObserver.observe(this.slider);
        this.slider.addEventListener('scroll', this.handleUpdate, { passive: true });
        window.addEventListener('resize', this.handleUpdate, { passive: true });

        requestAnimationFrame(this.handleUpdate);
    }

    update() {
        updateFloatingOverlays(this.container);

        if (this.cardsPaginationContainer.offsetHeight > 0) {
            this.cardsPaginationContainer.style.marginTop = `${this.cardsPaginationContainer.offsetHeight * -0.9}px`;
        }

        if (window.innerWidth >= 750) {
            this.pagination.hidden = true;
            return;
        }

        const visibleItems = this.items.filter((item) => item.clientWidth > 0);
        if (visibleItems.length < 2) {
            this.pagination.hidden = true;
            return;
        }

        const itemOffset = visibleItems[1].offsetLeft - visibleItems[0].offsetLeft;
        if (!itemOffset) {
            this.pagination.hidden = true;
            return;
        }

        const slidesPerPage = Math.max(
            1,
            Math.floor((this.slider.clientWidth - visibleItems[0].offsetLeft) / itemOffset)
        );
        const totalPages = Math.max(1, visibleItems.length - slidesPerPage + 1);
        const currentPage = Math.min(totalPages, Math.round(this.slider.scrollLeft / itemOffset) + 1);

        this.pagination.hidden = totalPages <= 1;

        if (this.currentPageElement) this.currentPageElement.textContent = String(currentPage);
        if (this.totalPagesElement) this.totalPagesElement.textContent = String(totalPages);
    }
}

class SlideshowSC {
    constructor(container) {
        this.container = container;
        this.band = container.querySelector('.sc-slideshow-band');
        if (!this.band) return;

        this.slides = Array.from(this.band.querySelectorAll('.sc-slide'));
        if (this.slides.length <= 1) return;

        this.dotsContainer = this.band.querySelector('.sc-slideshow-dots');
        this.prevBtn = this.band.querySelector('.sc-slide-arrow--prev');
        this.nextBtn = this.band.querySelector('.sc-slide-arrow--next');
        this.currentIndex = 0;
        this.autoRotate = this.band.dataset.autoplay === 'true';
        this.speed = (parseInt(this.band.dataset.speed, 10) || 5) * 1000;
        this.autoTimer = null;
        this.touchStartX = 0;

        this.buildDots();
        this.bindEvents();
        if (this.autoRotate) this.startAutoRotate();
    }

    buildDots() {
        if (!this.dotsContainer) return;

        this.dotsContainer.innerHTML = '';
        this.slides.forEach((_, i) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.setAttribute('aria-label', `Slide ${i + 1}`);
            btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
            btn.addEventListener('click', () => {
                this.stopAutoRotate();
                this.goTo(i);
            });
            this.dotsContainer.appendChild(btn);
        });
    }

    updateDots() {
        if (!this.dotsContainer) return;

        this.dotsContainer.querySelectorAll('button').forEach((btn, i) => {
            btn.setAttribute('aria-current', i === this.currentIndex ? 'true' : 'false');
        });
    }

    goTo(index) {
        this.slides[this.currentIndex].classList.remove('is-active');
        this.currentIndex = (index + this.slides.length) % this.slides.length;
        this.slides[this.currentIndex].classList.add('is-active');
        updateFloatingOverlays(this.container);
        this.updateDots();
    }

    next() {
        this.goTo(this.currentIndex + 1);
    }

    prev() {
        this.goTo(this.currentIndex - 1);
    }

    startAutoRotate() {
        this.autoTimer = setInterval(() => this.next(), this.speed);
    }

    stopAutoRotate() {
        if (!this.autoTimer) return;

        clearInterval(this.autoTimer);
        this.autoTimer = null;
    }

    bindEvents() {
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
                this.stopAutoRotate();
                this.prev();
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
                this.stopAutoRotate();
                this.next();
            });
        }

        this.band.addEventListener(
            'touchstart',
            (e) => {
                this.touchStartX = e.touches[0].clientX;
            },
            { passive: true }
        );

        this.band.addEventListener(
            'touchend',
            (e) => {
                const diff = this.touchStartX - e.changedTouches[0].clientX;
                if (Math.abs(diff) <= 40) return;

                this.stopAutoRotate();
                if (diff > 0) this.next();
                else this.prev();
            },
            { passive: true }
        );
    }
}

function initSlidesCardsSection(section) {
    if (!section || section.dataset.scInitialized === 'true') return;

    section.dataset.scInitialized = 'true';
    updateFloatingOverlays(section);
    new CardsCarouselSC(section);
    new SlideshowSC(section);
}

function initSlidesCardsSections() {
    document.querySelectorAll('.shapp-mcl-slides-cards').forEach((section) => {
        initSlidesCardsSection(section);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlidesCardsSections);
} else {
    initSlidesCardsSections();
}

document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.classList?.contains('shapp-mcl-slides-cards')
        ? e.target
        : e.target.querySelector('.shapp-mcl-slides-cards');

    if (section) initSlidesCardsSection(section);
});
